module.exports = __webpack_public_path__ + "img/card.bbb1b9c5.jpg";